let counter = 0;
let selector = "[bss-b2b-main-product-form]";

const interval = setInterval(() => {
    const element = document.querySelector(selector);
    const isBSSReady =
        window.BSS_B2B &&
        BSS_B2B.observer &&
        BSS_B2B.observer.productSubject;

    if (element && isBSSReady) {
        BSS_B2B.observer.productSubject.notifyObserver(
            'VariantChange',
            'VariantSelectChange',
            { productForm: element }
        );

        element.style.fontSize = "1.8rem";

        const price = element.querySelector("[bss-b2b-product-price]");
        if (price) {
            price.querySelectorAll("span").forEach(item => {
                item.style.fontSize = "1.8rem";
            });
        }

        clearInterval(interval);
    } else {
        counter += 100;
        if (counter >= 10000) {
            console.warn("Timeout: BSS_B2B hoặc element chưa load");
            clearInterval(interval);
        }
    }
}, 100);
